import '@/assets/styles/main.css';
import App from './apps/App.vue';
import router from './router/index';
import './styles/_app.css';
import intercomPlugin from '@/plugins/intercom';
import { createAppInstance } from '@/utils/appFactory';
import { initializeRouter } from '@/utils/routerInitializer';

const app = createAppInstance(App, router, [intercomPlugin]);

initializeRouter(router).then(() => {
  app.mount('#app');
});
